module.exports = __webpack_public_path__ + "img/9788956372563.4a6674fd.jpg";